import { ComplexValue, Value } from 'app/types-shared';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { DefaultFilterWire, DefaultFilterMetadataWire } from '../types';
import { DefaultFilter } from '../types-store';

const mapDomain = (domainWire: Value, filterMetadataWire: DefaultFilterMetadataWire[]): ComplexValue<number> => {

  const domain = codeItemToStoreValue(domainWire);
  const description = filterMetadataWire
    ?.find(metadata => metadata.domain?.v === domainWire?.v)
    ?.domain?.d;

  if (!domain || !description || domain.description === description) {
    return domain;
  }

  return {
    ...domain,
    description
  };
};

const sortFilters = (filter1: DefaultFilter, filter2: DefaultFilter): number => {
  const filter1HasSequence = !isDefinedIncludingZero(filter1.sequence) ? 1 : 0;
  const filter2HasSequence = !isDefinedIncludingZero(filter2.sequence) ? 1 : 0;

  return filter1HasSequence - filter2HasSequence !== 0
    ? filter1HasSequence - filter2HasSequence
    : (filter1.sequence ?? 0) - (filter2.sequence ?? 0) !== 0
      ? (filter1.sequence ?? 0) - (filter2.sequence ?? 0)
      : (filter1.domain?.description ?? '').localeCompare(filter2.domain?.description ?? '');
};

export const mapFiltersFromWire = (filters: DefaultFilterWire[], filterMetadataWire: DefaultFilterMetadataWire[]): DefaultFilter[] =>
  filters
    ?.map(filter => ({
      domain: mapDomain(filter.domain, filterMetadataWire),
      sequence: filter.sequence,
      myValue: filter.myValue,
      defaultValue: codeItemToStoreValue(filter.defaultValue),
      defaultValue2: codeItemToStoreValue(filter.defaultValue2),
      periodPredef: codeItemToStoreValue(filter.periodPredef)
    }))
    ?.sort(sortFilters) ?? [];

export const mapFiltersToWire = (filters: DefaultFilter[]): DefaultFilterWire[] =>
  filters?.map(filter => ({
    domain: { v: filter.domain?.value },
    sequence: filter.sequence,
    ...(filter.myValue !== undefined && { myValue: filter.myValue }),
    ...(!!filter.defaultValue && { defaultValue: { v: filter.defaultValue?.value } }),
    ...(!!filter.defaultValue2 && { defaultValue2: { v: filter.defaultValue2?.value } }),
    ...(!!filter.periodPredef && { periodPredef: { v: filter.periodPredef?.value } })
  })
  ) ?? [];
